import Container from '@/components/Container';
import EventBreadcrumb from '@/domain/Event/EventBreadcrumb';
import EventGallery from '@/domain/Event/EventGallery';
import client from '@/api/client';
import { eventGalleryQuery, eventGallerySlugsQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: eventGalleryQuery,
    variables: {
      id: params.slug,
    },
  });

  return {
    props: {
      event: data.event,
    }
  }
}

export async function getStaticPaths() {
  const { data } = await client().query({ query: eventGallerySlugsQuery });

  const events = data.events.nodes || [];

  let paths = [];

  if (events.length !== 0) {
    paths = events.map(({ slug, gallery }) => {
      if (gallery.images && gallery.images.length !== 0) {
        return {
          params: {
            slug,
          },
        };
      }
      return null;
    }).filter((e) => e !== null);
  }

  return {
    paths,
    fallback: false,
  };
}

export default function EventPhotoGallery({
  event,
}) {
  const categories = event.eventTypes?.nodes || [];

  return (
    <div className="bg-white">
      <div className="pt-10 pb-10 lg:pb-12">
        <Container className="space-y-4 lg:space-y-6">
          <EventBreadcrumb
            title={event.title}
            uri={event.uri}
            categories={categories}
            showEventPage
          />
          <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-10">
            <div className="lg:col-span-8">
              <div className="flex flex-col space-y-4">
                <h1 className="text-3xl lg:text-4xl font-bold tracking-tight">
                  {event.title}
                </h1>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <EventGallery photos={event?.gallery?.images || []} />
    </div>
  );
}
